import { RootState } from './../../store/store'

// Selector to access the complete user state
export const selectUserState = (state: RootState) => state.user

// Selector to select all user profiles from the state
export const selectAllUsers = (state: RootState) => state.user.allUsers

// Selector to select the profile of a single user
export const selectUserProfile = (state: RootState) => state.user.singleUser

// Selector to check if the user state is loading
export const selectUserLoading = (state: RootState) => state.user.isLoading

// Selector to retrieve any errors from the user state
export const selectUserError = (state: RootState) => state.user.error
